import { useState, useEffect } from 'react';
import {
  Box, Typography, TextField, Button, Table, TableHead,
  TableBody, TableRow, TableCell, FormControl, InputLabel, Select, MenuItem, Alert
} from '@mui/material';
import axios from 'axios';

const API = 'https://attend.zventures.in';

const HRManagement = ({ locations }) => {
  const [hrUsers, setHrUsers] = useState([]);
  const [form, setForm] = useState({ name: '', username: '', password: '', location: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/api/hr-users`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setHrUsers(r.data))
      .catch(console.error);
  }, []);

  const addHR = async () => {
    if (!form.name || !form.username || !form.password || !form.location) {
      setError('All fields are required'); return;
    }
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/api/hr-users`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setHrUsers(prev => [...prev, res.data]);
      setForm({ name: '', username: '', password: '', location: '' });
      setError('');
      setSuccess('HR user added successfully');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add HR user');
    }
  };

  const removeHR = async (username) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/api/hr-users/${username}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setHrUsers(prev => prev.filter(u => u.username !== username));
    } catch (err) {
      console.error('Error removing HR:', err);
    }
  };

  return (
    <Box sx={{ background: 'linear-gradient(to bottom right,#e6f0f9,#e6f0f9)', borderRadius: '10px', p: 3, mb: '5%' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 400 }}>Admin Panel – Manage HR Users</Typography>

      {error   && <Alert severity="error"   sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
        <TextField
          label="HR Full Name" value={form.name}
          onChange={e => setForm({ ...form, name: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 180 }}
        />
        <TextField
          label="Username" value={form.username}
          onChange={e => setForm({ ...form, username: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 160 }}
        />
        <TextField
          label="Password" type="password" value={form.password}
          onChange={e => setForm({ ...form, password: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 160 }}
        />
        <FormControl sx={{ minWidth: 160, backgroundColor: 'white' }}>
          <InputLabel>Assign Location</InputLabel>
          <Select value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} label="Assign Location">
            {locations.map(l => <MenuItem key={l.name} value={l.name}>{l.name}</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="contained" onClick={addHR}>Add HR</Button>
      </Box>

      <Box sx={{ borderRadius: 2, backgroundColor: '#ffffffcc', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 300, color: '#1e3a8a' }}>HR Users List</Typography>
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#f0f4ff' }}>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Username</strong></TableCell>
              <TableCell><strong>Assigned Location</strong></TableCell>
              <TableCell><strong>Action</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hrUsers.length === 0 ? (
              <TableRow><TableCell colSpan={4} align="center">No HR users added yet</TableCell></TableRow>
            ) : hrUsers.map(u => (
              <TableRow key={u.username}>
                <TableCell>{u.name}</TableCell>
                <TableCell>{u.username}</TableCell>
                <TableCell>{u.location}</TableCell>
                <TableCell>
                  <Button color="error" variant="outlined" size="small" onClick={() => removeHR(u.username)}>
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default HRManagement;